export let calendarDayOfWeek_Saturday = "zr4XX";
export default {calendarDayOfWeek_Saturday};